


























import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';
import button from '../../shared/directives/button.js';
import IconContainer from './IconContainer.vue';
import { alertType } from '../enums/alertType';
import { PropType } from 'vue';

export default {
  components: { IconContainer, Icon },
  directives: {
    button,
  },
  props: {
    type: {
      type: String as PropType<alertType>,
      default: 'information',
      validate: value => ['information', 'alert', 'warning'].includes(value),
    },
    showDelete: { type: Boolean, default: false },
  },
  emits: ['open', 'delete'],
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
  },
  methods: {
    emitOpen() {
      this.$emit('open');
    },
    emitDelete() {
      this.$emit('delete');
    },
  },
};
